import React from 'react';
import { SchematicShell, Line } from './SchematicPrimitives';

const IN = 0.0254;
const PANEL_THICK = 0.0625 * IN;
const BOTTOM_GAP = 0.5 * IN;
const LOUVER_ZONE_RATIO = 0.3;
const LOUVER_COUNT = 5;

export function BaseboardHeaterSchematic({
  widthMeters: width,
  heightMeters: height,
  depthMeters: depth,
  view = 'front',
  strokeColor,
  strokeWidth,
}) {
  if (view === 'left' || view === 'right') {
    return (
      <SchematicShell
        width={depth}
        height={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      >
        <g
          transform={
            view === 'right'
              ? `scale(-1, 1) translate(${-depth}, 0)`
              : undefined
          }
        >
          <SideView
            depth={depth}
            height={height}
            strokeColor={strokeColor}
            strokeWidth={strokeWidth}
          />
        </g>
      </SchematicShell>
    );
  }

  return (
    <SchematicShell
      width={width}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
    >
      <FrontView
        width={width}
        height={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
    </SchematicShell>
  );
}

function FrontView({ width, height, strokeColor, strokeWidth }) {
  const louverZoneH = height * LOUVER_ZONE_RATIO;
  const louverTop = 0;
  const slatSpacing = louverZoneH / LOUVER_COUNT;

  const elements = [];

  // Outer enclosure
  elements.push(
    <rect
      key="enclosure"
      x={0}
      y={0}
      width={width}
      height={height}
      fill="none"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      vectorEffect="non-scaling-stroke"
    />
  );

  // Louver slats (horizontal lines in the top section)
  for (let i = 0; i < LOUVER_COUNT; i++) {
    const y = louverTop + (i + 1) * slatSpacing;
    elements.push(
      <Line
        key={`louver-${i}`}
        x1={PANEL_THICK}
        y1={y}
        x2={width - PANEL_THICK}
        y2={y}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
    );
  }

  // Bottom air-intake gap line
  elements.push(
    <Line
      key="bottom-gap"
      x1={0}
      y1={height - BOTTOM_GAP}
      x2={width}
      y2={height - BOTTOM_GAP}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
    />
  );

  return <g>{elements}</g>;
}

function SideView({ depth, height, strokeColor, strokeWidth }) {
  const louverZoneH = height * LOUVER_ZONE_RATIO;

  return (
    <g>
      {/* Outer profile */}
      <rect
        x={0}
        y={0}
        width={depth}
        height={height}
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />

      {/* Divider between louver zone and solid front */}
      <Line
        x1={0}
        y1={louverZoneH}
        x2={depth}
        y2={louverZoneH}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />

      {/* Bottom gap */}
      <Line
        x1={depth * 0.5}
        y1={height - BOTTOM_GAP}
        x2={depth}
        y2={height - BOTTOM_GAP}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
    </g>
  );
}

BaseboardHeaterSchematic.supportsSideViews = true;
